import Link, { LinkProps } from "next/link"
import { useRouter } from "next/router"
import React from "react"
import styled from "styled-components"

import { Color, TextSize, SpacingSize, RadiusSize, Transition } from "~/consts/style-mixins"

interface IProps {
  size: "Small" | "Medium"
  href?: LinkProps["href"]
  onClick?: () => void
  disabled?: boolean
  isCurrent?: boolean
  children?: React.ReactNode
}
const SquareButton: React.FC<IProps> = ({ size = "Small", href, onClick, disabled, isCurrent, children }) => {
  const router = useRouter()

  return (
    <Link href={href || "#"} passHref={!disabled}>
      <StyledAnchor
        className={`${isCurrent ? "current" : ""}`}
        size={size}
        onClick={(e) => {
          e.preventDefault()
          if (disabled) {
            return
          } else if (typeof onClick === "function") {
            onClick()
          } else {
            router.push(href || "#")
          }
        }}
        disabled={disabled}
      >
        {children}
      </StyledAnchor>
    </Link>
  )
}

export default SquareButton

interface IStyledAnchorProps {
  size: "Small" | "Medium"
  disabled?: boolean
}
const StyledAnchor = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ size }: IStyledAnchorProps) => {
    if (size === "Medium") {
      return `
        min-width: 48px;
        min-height: 48px;
        font-size: ${TextSize.L}px;
      `
    }
    return `
      min-width: 32px;
      min-height: 32px;
      font-size: ${TextSize.XS}px;
    `
  }}
  cursor: ${({ disabled }: IStyledAnchorProps) => (disabled ? "not-allowed" : "pointer")};
  border: 1px solid ${Color.LightGray};
  border-radius: ${RadiusSize.Small}px;
  color: ${Color.LightGray};
  font-weight: bold;
  background: ${Color.White};
  ${Transition.Hover};
  svg {
    ${Transition.Hover};
  }
  &:not(:first-child) {
    margin-left: ${SpacingSize.XS}px;
  }
  &:hover {
    border: 1px solid ${Color.Gray};
    color: ${Color.Gray};
    background: ${Color.BackgroundGray};
    svg {
      fill: ${Color.Gray};
    }
  }
  &.current {
    border: 1px solid ${Color.Primary};
    color: ${Color.Primary};
    &:hover {
      border: 1px solid ${Color.Primary};
      color: ${Color.Primary};
      background: ${Color.White};
    }
  }
`
